import { styled } from '@mui/material/styles';
import { Link } from 'react-router-dom';
import IconButton from '@mui/material/IconButton';
import { MINT_MIST } from '../../constants/brandSurfaces';

const blue = '#0d4efe';
const ink = '#1a1a2e';
const muted = '#5a6478';

export const FooterWrapper = styled('footer')({
  background: MINT_MIST,
  borderTop: '1px solid rgba(26, 26, 46, 0.06)',
  color: muted,
});

export const FooterInner = styled('div')({
  maxWidth: 1440,
  margin: '0 auto',
  padding: '28px 24px 24px',
  '@media (max-width: 768px)': {
    padding: '24px 16px 20px',
  },
});

export const FooterTop = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  flexWrap: 'wrap',
  gap: 16,
  paddingBottom: 18,
  borderBottom: '1px solid rgba(26, 26, 46, 0.08)',
});

export const Brand = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: 12,
  textAlign: 'left',
});

export const BrandLogo = styled('img')({
  width: 36,
  height: 36,
  objectFit: 'contain',
});

export const BrandName = styled('p')({
  margin: 0,
  fontFamily: "'Plus Jakarta Sans', sans-serif",
  fontSize: '1.05rem',
  fontWeight: 700,
  color: ink,
});

export const BrandTagline = styled('p')({
  margin: 0,
  fontSize: '0.9rem',
  color: muted,
});

export const FooterActions = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: 4,
});

export const FooterSocialIconButton = styled(IconButton)({
  color: ink,
  '&:hover': {
    color: blue,
    background: 'rgba(13, 78, 254, 0.06)',
  },
});

export const ContactButton = styled(Link)({
  marginLeft: 8,
  padding: '8px 16px',
  borderRadius: 10,
  border: '1px solid rgba(26, 26, 46, 0.16)',
  background: '#ffffff',
  fontSize: '0.92rem',
  fontWeight: 700,
  color: ink,
  textDecoration: 'none',
  transition: 'border-color 0.15s ease, color 0.15s ease',
  '&:hover, &:focus-visible': {
    borderColor: blue,
    color: blue,
  },
});

export const FooterBottom = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  flexWrap: 'wrap',
  gap: '8px 20px',
  paddingTop: 14,
  fontSize: '0.85rem',
  '@media (max-width: 600px)': {
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
});

export const FooterLinks = styled('nav')({
  display: 'flex',
  flexWrap: 'wrap',
  gap: '6px 18px',
});

export const FooterLink = styled(Link)({
  color: muted,
  textDecoration: 'none',
  '&:hover, &:focus-visible': {
    color: blue,
    textDecoration: 'underline',
    textUnderlineOffset: 3,
  },
});

export const Copyright = styled('p')({
  margin: 0,
});
